import {
    CREATE_CALENDAR_SUCCESS,
    CLEAR_CREATED_CALENDAR,
    GET_ALL_CALENDARS_SUCCESS,
    GET_CALENDAR_SUCCESS,
    UPDATE_CALENDAR_SUCCESS,
    GET_PLAYER_CALENDAR_SUCCESS,
    DELETE_CALENDAR_SUCCESS,
    DUPLICATE_CALENDAR_SUCCESS,
    FILTER_CALENDAR_SUCCESS,
    UPDATE_DOOR_DRAG_DROP_SUCCESS
} from './constants';
import {
    UPDATE_CALENDAR_SETTINGS_SUCCESS,
    UPDATE_CALENDAR_REGISTRATION_SETTINGS_SUCCESS,
    SHOW_PUBLISH_SUCCESS
} from './settings/constants';

import { GET_CALENDAR_QUIZZES_LIST_SUCCESS } from './questions/constants';
import { UPDATE_CALENDAR_RULES_SUCCESS } from './navigation/rules/constants';
import { UPDATE_CALENDAR_WINNERS_SUCCESS } from './navigation/winners/constants';
import { GET_CALENDAR_APPEARANCE_LIST_SUCCESS } from './settings/constants';
import {
    CREATE_THEME_IN_CALENDAR_SUCCESS,
    DELETE_THEME_IN_CALENDAR_SUCCESS,
    UPDATE_THEME_IN_CALENDAR_SUCCESS
} from '../../data/appearance/constants';

import {
    STORE_FONT_IN_CALENDAR_SUCCESS,
    GET_FONTS_LIST_IN_CALENDAR_SUCCESS
} from '../../data/fonts/constants';
import  {
    SEND_REGISTRATION_AFTER_HATCH_SUCCESS,
    SEND_REGISTRATION_SUCCESS,
    SEND_REGISTRATION_AFTER_SUCCESS
} from '../player/register/constants';

const initialCalendarsState = {
    data: {}
};
/**
 *
 * @param state
 * @param action
 * @returns {{data: {}}|({data}&{data: {}, createdCalendar: *})|({data: {}}&{perPage: number, data: ({}), lastPage: *, currentPage: *})|({data}&{createdCalendar: null})|({data}&{data: (initialCalendarsState.data|{})})}
 */
const calendarsReducer = ( state = initialCalendarsState, action ) => {
    switch ( action.type ) {
        case CREATE_CALENDAR_SUCCESS:
        case DUPLICATE_CALENDAR_SUCCESS: {
            const newState = { ...state };
            const newCalndar = { [ action.calendar.id ]: action.calendar };

            return { ...newState, data: { ...newState.data, ...newCalndar }, createdCalendar: action.calendar.id };
        }
        case FILTER_CALENDAR_SUCCESS:
        case GET_ALL_CALENDARS_SUCCESS: {
            const calendars = action.calendars;
            const newState = calendars.current_page === 1 ? initialCalendarsState : { ...state };
            if ( !Object.keys( calendars.data ).length ) {
                return newState;
            }
            const calendarsObj = {};
            Object.values( calendars.data ).map( item => calendarsObj[ item.id ] = item );
            return {
                ...newState,
                data: { ...newState.data, ...calendarsObj },
                perPage:
                    calendars.current_page + 1 === calendars.last_page
                        ? calendars.total - calendars.to
                        : calendars.per_page,
                currentPage: calendars.current_page,
                lastPage: calendars.last_page
            };
        }
        case CLEAR_CREATED_CALENDAR: {
            return {
                ...state,
                createdCalendar: null
            };
        }
        case DELETE_CALENDAR_SUCCESS: {
            const newStateData = { ...state.data };
            delete newStateData[ action.id ];
            return { ...state, data: newStateData };
        }


        default:
            return state;
    }
};

const initialCalendarState = {
    quizzes_list: []
};
/**
 *
 * @param state
 * @param action
 * @returns {({quizzes_list}&{rules: *})|({quizzes_list}&{appearances: ...*[]})|{quizzes_list: Array}|({quizzes_list}&{quizzes_list})|({quizzes_list}&{fonts: *})|({quizzes_list}&{appearances: (*|*[]|...*[])})|({quizzes_list}&{winners: (*|boolean)})|({quizzes_list}&{settings: *})|({quizzes_list}&{appearances: *[]})|({quizzes_list}&{appearances: null})}
 */
const calendarReducer = ( state = initialCalendarState, action ) => {
    switch ( action.type ) {

        case GET_CALENDAR_SUCCESS:
        case UPDATE_CALENDAR_SUCCESS:
        case UPDATE_CALENDAR_REGISTRATION_SETTINGS_SUCCESS: {
            return { ...state, ...action.calendar };
        }
        case GET_PLAYER_CALENDAR_SUCCESS: {
            return { ...state, ...action.playerCalendar };
        }
        case UPDATE_CALENDAR_SETTINGS_SUCCESS: {
            return { ...state, settings: action.settings };
        }
        case GET_CALENDAR_QUIZZES_LIST_SUCCESS: {
            return { ...state, quizzes_list: action.quizzesList };
        }
        case UPDATE_CALENDAR_RULES_SUCCESS: {
            return { ...state, rules: action.rules };
        }
        case UPDATE_CALENDAR_WINNERS_SUCCESS: {
            return { ...state, winners: action.winners };
        }
        case GET_CALENDAR_APPEARANCE_LIST_SUCCESS: {
            return { ...state, appearances: action.appearances };
        }
        case CREATE_THEME_IN_CALENDAR_SUCCESS: {
            const appearance = [ ...state.appearances, action.theme ];
            return { ...state, appearances: appearance };
        }
        case DELETE_THEME_IN_CALENDAR_SUCCESS: {
            const selectedThemeID = state.appearances.find( theme => theme.selected ).id;
            let themeIndex;
            if ( selectedThemeID !== action.deletedID ) {
                themeIndex = action.themes.indexOf( action.themes.find( theme => theme.id === selectedThemeID ) );
                action.themes[ themeIndex ].selected = true;
            } else {
                action.themes[ 0 ].selected = true;
            }

            return { ...state, appearances: action.themes };
        }
        case UPDATE_THEME_IN_CALENDAR_SUCCESS: {
            const themeIndex = state.appearances.indexOf( state.appearances.find( theme => theme.id === action.theme.id ) )
            let appearances = state.appearances;
            if ( appearances[ themeIndex ].selected ) {
                action.theme.selected = true;
            }
            appearances[ themeIndex ] = action.theme;
            return { ...state, appearances: [ ...appearances ] };
        }
        case STORE_FONT_IN_CALENDAR_SUCCESS: {
            return { ...state, fonts: action.fonts };
        }
        case GET_FONTS_LIST_IN_CALENDAR_SUCCESS: {
            return { ...state, fonts: action.fonts };
        }
        case UPDATE_DOOR_DRAG_DROP_SUCCESS : {
            return { ...state, ...action.calendar };
        }
        case SEND_REGISTRATION_AFTER_HATCH_SUCCESS:{
            return { ...state, ...action.user};
        }
        case SEND_REGISTRATION_SUCCESS:{
            return { ...state, ...action.user };
        }
        default:
            return state;
    }
};

const publishState = {
    showPupUp: null
};

/**
 *
 * @param state
 * @param action
 * @returns {({showPupUp}&{showPupUp: *})|{showPupUp: null}}
 */
const publishReducer = ( state = publishState, action ) => {
    switch ( action.type ) {
        case SHOW_PUBLISH_SUCCESS: {
            return { ...state, showPupUp: action.value };
        }
        default:
            return state;
    }
};

export { calendarsReducer as calendars, calendarReducer as calendar, publishReducer as publish };